import { render, staticRenderFns } from "./CustomerAssigneProvider.vue?vue&type=template&id=6086496c&scoped=true"
import script from "./CustomerAssigneProvider.vue?vue&type=script&lang=js"
export * from "./CustomerAssigneProvider.vue?vue&type=script&lang=js"
import style0 from "./CustomerAssigneProvider.vue?vue&type=style&index=0&id=6086496c&prod&lang=scss&scoped=true"
import style1 from "./CustomerAssigneProvider.vue?vue&type=style&index=1&id=6086496c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6086496c",
  null
  
)

export default component.exports